import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import React from "react";
import strings from "../../config/localization";

interface Props {
  onClickHandler?: () => void;
  label?: string;
}

export default function DeleteButton({
  onClickHandler = () => {},
  label = strings.delete,
}: Props) {
  return (
    <Button
      variant="outlined"
      color="error"
      size="small"
      startIcon={<DeleteIcon />}
      onClick={onClickHandler}
    >
      {label}
    </Button>
  );
}
